(function () {

    // Output
    var outputDropAjax = document.getElementById('filter-output');

    // Checkbox click event
    let checkBox = document.querySelectorAll('.horizontal-filter .checkbox');
    for (let i = 0; i < checkBox.length; i++) {
        checkBox[i].addEventListener("click", function () {
            ajaxDropSrollToSection();
            let screenWidth = (window.innerWidth > 0) ? window.innerWidth : document.documentElement.clientWidth;
            if(screenWidth > 991) {
                // Call the function to remove the 'show' class on filter
                removeAccordionShowClass();
                collapseSpanDropArrowOnFilter();
            }
            filterDropProduct();
        });
    }
    
    // Clear filter
    let clearMobileFilter = document.getElementById('clear-filter-mobile');
    if (clearMobileFilter) {
        clearMobileFilter.addEventListener("click", function () {
            ajaxDropSrollToSection();
            // Iterate through each checkbox and uncheck it
            checkBox.forEach(function (item) {
                item.checked = false;
            });
            
            filterDropProduct();
        })
    }

    // Clear filter mobile
    let clearFilter = document.getElementById('clear-filter');
    if (clearFilter) {
        clearFilter.addEventListener("click", function () {
            ajaxDropSrollToSection();
            // Iterate through each checkbox and uncheck it
            checkBox.forEach(function (item) {
                item.checked = false;
            });
            
            filterDropProduct();
        })
    }
    let clearFilterDesk = document.getElementById("clear-ajax-dropdown");
    if (clearFilterDesk) {
        clearFilterDesk.addEventListener("click", function () {
            ajaxDropSrollToSection();
            // Iterate through each checkbox and uncheck it
            checkBox.forEach(function (item) {
                item.checked = false;
            });
    
          filterDropProduct();
        });
    }

    paginationDropFilter();

    // Pagination function
    function paginationDropFilter() {
        let pagination = document.querySelectorAll('.pagination .page-link');
        for (let i = 0; i < pagination.length; i++) {
            pagination[i].addEventListener("click", function (e) {
                e.preventDefault();
                ajaxDropSrollToSection();
                let pageNo = pagination[i].getAttribute('data-pageno');

                filterDropProduct(pageNo);
            });
        }
    }

    // Filter product function
    function filterDropProduct(page = 1) {
        ajaxDropLoaderShow();

        let categoriesChoices = {};
        let attributesChoices = {};

        // Getting values from catergories checkbox
        let categories = document.querySelectorAll('.ecommerce-drop-ajax-filter .categories input[type=checkbox]');
        for (let i = 0; i < categories.length; i++) {
            /* if category item is clicked */
            if (categories[i].checked) {
                if (!categoriesChoices.hasOwnProperty(categories[i].name)) {
                    categoriesChoices[categories[i].name] = [categories[i].value];
                }
                else {
                    categoriesChoices[categories[i].name].push(categories[i].value);
                }
            }
        }

        // add/remove active class if categoriesChoices has any values
        let parentCatElements = document.querySelectorAll('.filter-list.accordion-item.categories');
        // Check if categoriesChoices has any values
        let catHasValues = Object.keys(categoriesChoices).length > 0;
        // Iterate through all elements with the class 'categories'
        parentCatElements.forEach(parentCatElement => {
            if (catHasValues) {
                // Add 'active' class to each element
                parentCatElement.classList.add('active');
            } else {
                // Remove 'active' class from each element
                parentCatElement.classList.remove('active');
            }
        });
        
        // Getting values from atrtributes checkbox
        let attributes = document.querySelectorAll('.ecommerce-drop-ajax-filter .attributes input[type=checkbox]');
        for (let i = 0; i < attributes.length; i++) {
            if (attributes[i].checked) {
                if (!attributesChoices.hasOwnProperty(attributes[i].name))
                    attributesChoices[attributes[i].name] = [attributes[i].value];
                else
                attributesChoices[attributes[i].name].push(attributes[i].value);
            }
        }

        // Function to check if any checkboxes are checked in a given group
        function anyAttributesChecked(groupClassName) {
            let checkboxes = document.querySelectorAll('.' + groupClassName + ' input[type="checkbox"]');
            return Array.from(checkboxes).some(checkbox => checkbox.checked);
        }

        // Function to update the 'active' class based on checkbox states
        function updateActiveAttributeItemClass() {
            let attributesParents = document.querySelectorAll('.attribute-list.attributes');

            attributesParents.forEach(parent => {
                let groupClassName = parent.getAttribute('data-attribute-slug');
                if (anyAttributesChecked(groupClassName)) {
                    parent.classList.add('active');
                } else {
                    parent.classList.remove('active');
                }
            });
        }

        // Add event listeners to all checkboxes
        document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
            checkbox.addEventListener('change', updateActiveAttributeItemClass);
        });

        // Initial call to update active class on page load
        updateActiveAttributeItemClass();        
        
        // Categories data to send in request
        let categoriesData = '';
        for (let key in categoriesChoices) {
            if (categoriesChoices.hasOwnProperty(key)) {
                let categoriesArray = categoriesChoices[key];

                for (let i = 0; i < categoriesArray.length; i++) {
                    categoriesData += '&categoriesChoices%5B' + key + '%5D%5B%5D=' + categoriesArray[i];
                }
            }
        }

        // Attributes data to send in request
        let attributesData = '';
        for (let key in attributesChoices) {
            if (attributesChoices.hasOwnProperty(key)) {
                let attributesArray = attributesChoices[key];

                for (let i = 0; i < attributesArray.length; i++) {
                    attributesData += '&attributesChoices%5B' + key + '%5D%5B%5D=' + attributesArray[i];
                }
            }
        }

        // Function to toggle the visibility of the clear button based on selected attributes and categories
        function toggleClearButtonVisibility() {
            let clearButton = document.getElementById('clear-filter');
            let clearButtonDesk = document.getElementById('clear-ajax-dropdown');
            let clearFilterMobile = document.getElementById('clear-filter-mobile');
            let attributesParents = document.querySelectorAll('.attribute-list.attributes');
            let categoriesParent = document.querySelector('.categories');
            
            let anyAttributeSelected = Array.from(attributesParents).some(parent => {
                return parent.classList.contains('active');
            });
            
            let anyCategorySelected = categoriesParent.classList.contains('active');
            
            if (anyAttributeSelected || anyCategorySelected) {
                if(clearButton) {
                    clearButton.style.display="block";
                }
                if(clearFilterMobile) {
                    clearFilterMobile.style.display="block";
                }
                if(clearButtonDesk) {
                    clearButtonDesk.style.display="block";
                }
            } else {
                if(clearButton) {
                    clearButton.style.display="none";
                }
                if(clearFilterMobile) {
                    clearFilterMobile.style.display="none";
                }
                if(clearButtonDesk) {
                    clearButtonDesk.style.display="none";
                }
            }
        }
        
        // Initial call to toggle clear button visibility on page load
        toggleClearButtonVisibility();

        // Add event listeners to all checkboxes
        document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
            checkbox.addEventListener('change', function() {
                toggleClearButtonVisibility();
            });
        });
        
        // Page data to send in request
        let pageData = '&pageNo=' + page;
        let pageUrlValue = document.getElementById('page-url').value;
        pageUrl = "&pageurl=" + pageUrlValue;

        // Ajax request
        let request = new XMLHttpRequest();
        request.open('POST', ajax_callback_data.ajax_url, true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8'); 
        request.onreadystatechange = () => {
            if (request.readyState === 4) {
                if(request.response === 'no-product') {
                    responseHtml = '<span class="no-result">No Products Found</span>';
                } else {
                    responseHtml = request.response;
                }
                outputDropAjax.innerHTML = responseHtml;
                
                paginationDropFilter();
                
                ajaxDropLoaderHide();

            }
        } 
        request.send('action=woocommerce_ajax_filter_products&nonce=' + ajax_callback_data.ajax_nonce + categoriesData + attributesData + pageData + pageUrl);

    }
    
    // Function to remove the 'show' class from all elements with the class 'accordion-collapse'
    function removeAccordionShowClass() {
        let accordionCollapseElements = document.querySelectorAll('.accordion-collapse');
        accordionCollapseElements.forEach(element => {
            element.classList.remove('show');
        });
    }

    function collapseSpanDropArrowOnFilter() {
        let spanCollapse = document.querySelectorAll('.accordion-button');
        spanCollapse.forEach((spanCollapse) => {
            spanCollapse.classList.add('collapsed');
        });
    }

    function ajaxDropLoaderShow() {
        document.getElementById('loading').style.display = "flex";
    }

    function ajaxDropLoaderHide() {
        document.getElementById('loading').style.display = "none";
    }

    function ajaxDropSrollToSection() {
        let yOffset = -112; // Adjust this value to scroll more or less
        let SidebarScrollY = outputDropAjax.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: SidebarScrollY, behavior: 'smooth' });
    }

})();